/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbAdmissionCoordinatorPage } from './HchbAdmissionCoordinatorPage';
import {
    HchbAdmissionCoordinatorPageFromJSON,
    HchbAdmissionCoordinatorPageFromJSONTyped,
    HchbAdmissionCoordinatorPageToJSON,
} from './HchbAdmissionCoordinatorPage';

/**
 * 
 * @export
 * @interface FindAllHchbAdmissionCoordinators200Response
 */
export interface FindAllHchbAdmissionCoordinators200Response {
    /**
     * 
     * @type {HchbAdmissionCoordinatorPage}
     * @memberof FindAllHchbAdmissionCoordinators200Response
     */
    data?: HchbAdmissionCoordinatorPage;
}

/**
 * Check if a given object implements the FindAllHchbAdmissionCoordinators200Response interface.
 */
export function instanceOfFindAllHchbAdmissionCoordinators200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbAdmissionCoordinators200ResponseFromJSON(json: any): FindAllHchbAdmissionCoordinators200Response {
    return FindAllHchbAdmissionCoordinators200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbAdmissionCoordinators200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbAdmissionCoordinators200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbAdmissionCoordinatorPageFromJSON(json['data']),
    };
}

export function FindAllHchbAdmissionCoordinators200ResponseToJSON(value?: FindAllHchbAdmissionCoordinators200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbAdmissionCoordinatorPageToJSON(value.data),
    };
}

